import React from "react";
import ComponentWrapper from "../Shared/ComponentWrapper";
import LottieAnimation from "../Shared/LottieAnimation";
import supplyEarnYieldAnimation from "../../data/Supply-&-Earn-Yield.json";
import borrowInstantly from "../../data/Borrow-Instantly.json";
import composabilityIntegrations from "../../data/Composability-&-dApp-Integrations.json";
import riskIsolatedMarkets from "../../data/Risk-Isolated-Markets.json";

const Features = () => {
  return (
    <ComponentWrapper styles="w-full pt-[10rem] sm:pt-[7rem]">
      <div id="about" className="flex justify-center items-center flex-col gap-4">
        <h2 className="text-[40px] mx-auto max-w-[530px] text-blue-1 leading-[48px] text-center">
          One AI agent. Every blockchain action.
        </h2>
        <p className="text-[18px] mx-auto max-w-[530px] text-gray-1 leading-[28px] text-center">
          Helix AI understands your intent and executes complex blockchain
          operations on your behalf — no manual UIs or technical knowledge required.
        </p>
        <div className="w-full pt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {FeaturesData.map((item, index) => {
            return (
              <div key={index} className="w-full border-[1px] border-[#F0F0F5] rounded-[24px] flex flex-col ">
                <div className="w-full !overflow-hidden h-[150px] sm:h-[238px]">
                  <LottieAnimation
                    animationData={item.animation}
                    width="100%"
                    height="100%"
                  />
                </div>
                <div className="flex p-4 flex-col gap-3">
                  <div className="bg-blue-2 rounded-[8px] w-[32px] h-[32px] flex justify-center items-center">
                    <img
                      src={item.icon}
                      alt=""
                      className="w-[24px] h-[24px]"
                    />
                  </div>
                  <p className="text-[20px] text-blue-1 font-medium">
                    {item.title}
                  </p>
                  <p className="text-gray-1 text-[16px] font-normal">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </ComponentWrapper>
  );
};

export default Features;

const FeaturesData = [
  {
    title: "Deploy Smart Contracts",
    description:
      "Launch ERC-20 tokens or deploy custom Solidity contracts with OpenZeppelin imports — just describe what you need in plain English.",
    icon: "/icons/desk.svg",
    animation: supplyEarnYieldAnimation,
    link: "/deploy-contracts",
  },
  {
    title: "Swap Tokens Instantly",
    description:
      "Execute token swaps across DEX aggregators with a single message. Helix AI finds the best route and rate for you automatically.",
    icon: "/icons/charity.svg",
    animation: borrowInstantly,
    link: "/swap-tokens",
  },
  {
    title: "Transfer Tokens",
    description:
      "Send ETH or any ERC-20 token to any address on Ethereum — just describe the transfer and confirm.",
    icon: "/icons/radar.svg",
    animation: composabilityIntegrations,
    link: "/transfer-tokens",
  },
  {
    title: "Manage Your Portfolio",
    description:
      "Check balances, view NFTs, and track your swap history on Ethereum in one conversation.",
    icon: "/icons/check.svg",
    animation: riskIsolatedMarkets,
    link: "/portfolio",
  },
];
